













































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { mdiChevronDown, mdiCheck, mdiSort } from '@mdi/js'
import LazyHydrate from 'vue-lazy-hydration'
import vClickOutside from 'v-click-outside'
import { IStyle } from '~/assets/interfaces/classes'
import { filterUrl } from '~/assets/filters/url'
Vue.use(vClickOutside)

@Component({
  components: {
    LazyHydrate,
    ComponentIcon: () => import('../icon/icon.vue'),
  },
})
export default class ComponentCatalogSorting extends Vue {
  @Prop({ type: Array, default: () => [] }) private items!: any[]
  @Prop({ type: Boolean, default: false }) private showIconSort: boolean

  private icons = { mdiChevronDown, mdiCheck, mdiSort }

  private get activeItem() {
    return this.items.find((item) => item.active)
  }

  private isOpen = false

  private clickOutsideHandler() {
    this.isOpen = false
  }

  private selectSorting(e: any) {
    const query = { ...this.$route.query }
    query.sorting = e.value
    if (query.page) {
      query.page = '1'
    }

    if (query.showMore) {
      query.showMore = '0'
    }

    this.$router.push({
      path: filterUrl(this.$route.path),
      query,
    })
    this.isOpen = false
  }

  private $style!: IStyle
  private get classSorting() {
    return {
      [this.$style.sorting]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  private mounted() {
    this.$emit('loaded')
  }
}
